<template>
    <div class="d-flex flex-column flex-fill lower-scroll" style="overflow: auto;">
        <v-expansion-panels multiple v-model="openPanels" flat>
            <v-expansion-panel
                v-for="(p,i) in plans"
                class="plan-container"
                style="background: white"
            >
                <v-expansion-panel-header style="display: flex; border-bottom: 1px solid #dddddd;">
                    <div class="d-flex">
                        <div class="plan-title">
                            {{ p.name }}

                            <div class="plan-detail d-flex">
                                <div style="padding-top: 2px;" class="mr-2">
                                    {{ p.intervention_type_name.substring(0, 20) }}
                                </div>

                                <v-icon style="font-size: 6px">fas fa-circle</v-icon>

                                <div style="padding-top: 2px;" class="mx-2">{{ interventionists(p) }}</div>

                                <v-icon style="font-size: 6px">fas fa-circle</v-icon>

                                <div style="padding-top: 2px;" class="mx-2">
                                    {{ isActive(p.intervention_end_date) ? 'Active Phase' : 'Past Phase' }}
                                </div>
                            </div>
                        </div>

                        <v-spacer/>
                        <div style="font-size: 14px; padding-top: 10px; margin-right: 8px; color: #050F2D">
                            {{ $dayjs(p.intervention_start_date).format('MMM DD') }} -
                            {{ $dayjs(p.intervention_end_date).format('MMM DD, YYYY') }}
                        </div>
                    </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content style="min-width: 800px;">
                    <div v-for="intv in matchingInterventions(p)">
                        <academic-progress-monitoring :monitorDecisions="isActive(p.intervention_end_date)" v-if="intv.category_id!==4" :params="{ student_id: params.student_id, intervention_id: intv.id }" :messageParams="{ intervention_plan_id: p.id, student_id: params.student_id }" :currentMonitors="[p]" />
                        <behavior-progress-monitoring style="min-height: 300px;" v-if="intv.category_id===4" :params="{ student_id: params.student_id, intervention_id: intv.id }" :include-summary="false"/>

                        <div class="tools d-flex" :class="{'academic': intv.category_id !== 4}">
                            <fe-icon-btn small useIcon="far fa-hands-heart" @click="showIntervention(p)"/>
                            <fe-icon-btn small useIcon="far fa-comment" @click="showComments(intv)"/>
                        </div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <fe-dialog
            title="Student Comments"
            width="800"
            v-if="messageDialog.show"
            @accept="() => $refs.msgCreate.doSubmit()"
            @close="messageDialog.show=false"
            persistent
            dismissButtonText="Cancel"
            acceptButtonText="Create"
            :retain-focus="false"
        >
            <message
                ref="msgCreate"
                @created="messageDialog.show=false"
                dense
                create-only
                hide-submit
                :params="messageDialog.params"
            />
        </fe-dialog>
    </div>
</template>

<script>
    import AcademicProgressMonitoring from '@/components/charts/AcademicProgressMonitoring'
    import BehaviorProgressMonitoring from '@/components/charts/BehaviorProgressMonitoring'
    import Message from '@/components/common/Message'

    export default {
        name: 'Interventions',
        components: { AcademicProgressMonitoring, BehaviorProgressMonitoring, Message },
        props: {
            params: {

            }
        },
        data () {
            return {
                interventions: [],
                messageDialog: {
                    show: false,
                    params: {}
                },
                plans: [],
                openPanels: [],
                windowWidth: window.innerWidth,
            }
        },
        created() {
            this.loadData()
        },
        computed: { },
        methods: {
            loadData() {
                this.$axios.get('interventionView.php?action=get&property=intervention&'+this.$objectToParams(this.params))
                    .then(r => {
                        this.interventions = this.$ecResponse(r, 'interventions')
                        this.plans = this.interventions.flatMap(i => 
                            i.plans.flatMap(plan => ({ ...plan, intervention_id : i.id }))
                        )
                    })
            },
            showComments(rec) {
                this.messageDialog.show=true
                this.messageDialog.params={ student_id: this.params.student_id, intervention_id: rec.id }
            },
            showIntervention(rec) {
                this.$dockableWindow({
                    name: 'Intervention Groups',
                    component: 'intervention-workspace',
                    attrs: {
                        interventionPlanId: rec.id
                    }
                })
            },
            interventionists(plan) {
                return plan.interventionists.map(interventionist => interventionist.name).join(', ')
            },
            matchingInterventions(plan) {
                return this.interventions.filter(intv => intv.id === plan.intervention_id)
            },
            isActive(date) {
                return this.$dayjs(date).isAfter(this.$dayjs(), 'day')
            }
        },
    }
</script>

<style lang="scss" scoped>
.tools {
    position: absolute;
    top: 75px;
    right: 65px;
    &.academic {
        right: 85px;
    }
}
.plan-container {
    background: #FFFFFF;
    border: 1px solid #E0E1E6;
    box-sizing: border-box;
    margin-top: 0;
    .plan-title {
        font-size: 14px;
        font-weight: 500;
        color: #2B3963;

        .plan-detail {
            font-size: 12px;
            line-height: 16px;
        }
    }

    .fidelity-container {
        cursor: pointer;
        border-right: 1px solid #dddddd;
        padding: 16px;

        &-attendance {
            align-items: center;
            padding-left: 12px;
            padding-right: 12px;
        }

        .fidelity-stats {
            width: 50%;
        }
    }

    .fidelity-container:has(.fidelity-container-attendance) {
        border-right: none !important;
    }

    .monitor-container {
        cursor: pointer;
        border-right: 1px solid #dddddd;
        flex: 1 1 auto;
        padding: 16px;
    }

    .decision-container {
        cursor: pointer;
        padding: 16px;
    }
}
</style>
